var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "c-textarea-wrapper" },
    [
      _vm.label
        ? _c(
            "label",
            {
              staticClass: "c-textarea-label",
              class: _vm.labelClass,
              attrs: { for: _vm.id },
            },
            [
              _vm._v("\n        " + _vm._s(_vm.label)),
              _vm.required ? [_vm._v("*")] : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "w-100" }, [
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _setup.model,
              expression: "model",
            },
          ],
          staticClass: "form-control",
          class: _setup.computedClass,
          attrs: {
            id: _vm.id,
            disabled: _vm.disabled,
            placeholder: _vm.placeholder,
            required: _vm.required,
            minlength: _vm.minlength,
            maxlength: _vm.maxlength,
            rows: _vm.rows,
          },
          domProps: { value: _setup.model },
          on: {
            blur: function ($event) {
              return _setup.emit("blur", _setup.model)
            },
            keyup: _setup.onKeyup,
            input: [
              function ($event) {
                if ($event.target.composing) return
                _setup.model = $event.target.value
              },
              _setup.triggerDebounce,
            ],
          },
        }),
      ]),
      _vm._v(" "),
      _vm.error
        ? _c(_setup.CError, { attrs: { message: _vm.errorMsg } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }